(function () {
  let modalEl = null;
  let previousBodyOverflow = '';
  let releaseFocusTrap = null;
  let previousFocusedElement = null;

  function createModal() {
    if (modalEl) return;

    modalEl = document.createElement('div');
    modalEl.id = 'et-contact-modal';

    modalEl.innerHTML =
      '' +
      '<div class="et-contact-modal-container" role="dialog" aria-modal="true" aria-label="Contact us">' +
      '<button id="et-contact-close" type="button" aria-label="Close">\u00D7</button>' +
      '<div style="background: #0d3c3a; color: #fff; padding: 24px; border-radius: 8px 8px 0 0; margin-bottom: 0;">' +
      '<h1 style="margin: 0; font-size: 24px; font-weight: 600; color: #fff;">Contact us</h1>' +
      '</div>' +
      '<div style="background: #f7f6ef; padding: 32px 20px; border-radius: 0 0 8px 8px; min-height: 500px;">' +
      '<div style="margin-bottom: 24px;">' +
      '<h2 style="font-size: 32px; font-weight: 700; color: #222; margin: 0 0 8px 0;">Hi there,</h2>' +
      '<p style="font-size: 16px; color: #666; margin: 0;">Here are the ways for you to get in touch.</p>' +
      '</div>' +
      '<div style="background: #fff; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.06); max-width: 600px;">' +
      '<a href="mailto:support@everytable.com" style="display: flex; align-items: center; gap: 16px; padding: 24px 10px; border-bottom: 1px solid #f0f0f0; text-decoration: none; color: inherit; transition: background 0.2s; cursor: pointer;">' +
      '<div style="width: 44px; height: 44px; flex-shrink: 0; display: flex; align-items: center; justify-content: center;">' +
      '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#0d3c3a" stroke-width="2">' +
      '<rect x="3" y="5" width="18" height="14" rx="2"></rect>' +
      '<path d="M3 7l9 6 9-6"></path>' +
      '</svg>' +
      '</div>' +
      '<div style="flex: 1;">' +
      '<div style="font-size: 18px; font-weight: 600; color: #222; margin-bottom: 4px;">Email us</div>' +
      '<div style="font-size: 14px; color: #666;">support@everytable.com</div>' +
      '</div>' +
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">' +
      '<path d="M9 18l6-6-6-6"></path>' +
      '</svg>' +
      '</a>' +
      '<a href="https://calendly.com/everytable-support/30min" target="_blank" rel="noopener noreferrer" style="display: flex; align-items: center; gap: 16px; padding: 24px 10px; border-bottom: 1px solid #f0f0f0; text-decoration: none; color: inherit; transition: background 0.2s; cursor: pointer;">' +
      '<div style="width: 44px; height: 44px; flex-shrink: 0; display: flex; align-items: center; justify-content: center;">' +
      '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#0d3c3a" stroke-width="2">' +
      '<circle cx="12" cy="12" r="10"></circle>' +
      '<path d="M12 6v6l4 2"></path>' +
      '</svg>' +
      '</div>' +
      '<div style="flex: 1;">' +
      '<div style="font-size: 18px; font-weight: 600; color: #222; margin-bottom: 4px;">Schedule callback</div>' +
      '</div>' +
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">' +
      '<path d="M9 18l6-6-6-6"></path>' +
      '</svg>' +
      '</a>' +
      '<a href="/pages/faqs" target="_blank" rel="noopener noreferrer" style="display: flex; align-items: center; gap: 16px; padding: 24px 10px; text-decoration: none; color: inherit; transition: background 0.2s; cursor: pointer;">' +
      '<div style="width: 44px; height: 44px; flex-shrink: 0; display: flex; align-items: center; justify-content: center;">' +
      '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#0d3c3a" stroke-width="2">' +
      '<circle cx="12" cy="12" r="10"></circle>' +
      '<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>' +
      '<circle cx="12" cy="17" r="0.5" fill="#0d3c3a"></circle>' +
      '</svg>' +
      '</div>' +
      '<div style="flex: 1;">' +
      '<div style="font-size: 18px; font-weight: 600; color: #222; margin-bottom: 4px;">FAQs</div>' +
      '<div style="font-size: 14px; color: #666;">Find answers to commonly asked questions.</div>' +
      '</div>' +
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">' +
      '<path d="M9 18l6-6-6-6"></path>' +
      '</svg>' +
      '</a>' +
      '</div>' +
      '</div>' +
      '</div>';

    document.body.appendChild(modalEl);

    const closeBtn = modalEl.querySelector('#et-contact-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    modalEl.addEventListener('click', function (event) {
      if (event.target === modalEl) {
        closeModal();
      }
    });
  }

  function openModal() {
    createModal();
    previousFocusedElement =
      document.activeElement instanceof HTMLElement ? document.activeElement : null;
    modalEl.style.display = 'flex';
    previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const modalContainer = modalEl.querySelector('.et-contact-modal-container');
    const trapFocus = window.etRechargeUtils?.trapFocus;
    if (typeof trapFocus === 'function' && modalContainer instanceof HTMLElement) {
      if (typeof releaseFocusTrap === 'function') {
        releaseFocusTrap();
      }
      releaseFocusTrap = trapFocus(modalContainer, {
        onEscape: closeModal,
      });
    }
  }

  function closeModal() {
    if (typeof releaseFocusTrap === 'function') {
      releaseFocusTrap();
      releaseFocusTrap = null;
    }
    if (modalEl) {
      modalEl.style.display = 'none';
      document.body.style.overflow = previousBodyOverflow || '';
    }
    if (
      previousFocusedElement instanceof HTMLElement &&
      document.contains(previousFocusedElement)
    ) {
      previousFocusedElement.focus();
      previousFocusedElement = null;
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      const contactBtn =
        event.target.closest &&
        event.target.closest('#et-contact-sidebar-nav, #et-contact-sidebar-link');
      if (!contactBtn) return;

      event.preventDefault();
      openModal();
    },
    true
  );

  document.addEventListener(
    'Recharge::location::change',
    function () {
      closeModal();
    },
    true
  );

  window.etContactUs = window.etContactUs || {};
  window.etContactUs.open = openModal;
  window.etContactUs.close = closeModal;
})();
